import { IChecklistItem, ChecklistItemStatus } from './../types/checklist_types';
import { Strategy } from 'utility-ts-strategy';

export interface IChecklistItemStrategy {
  type: () => string;
  isCompletable: (item: IChecklistItem) => boolean;
  isUndoable: (item: IChecklistItem) => boolean;
  canAddBackToChecklist: (item: IChecklistItem) => boolean;
  transitionToStatus: () => ChecklistItemStatus;
  cancelTransitionStatus?: () => ChecklistItemStatus;
}

angular.module('capability-ng-checklist').constant(
  'ngChecklistItemStrategy',
  new Strategy<IChecklistItemStrategy>({
    normal: {
      type: () => 'To-Do',
      isCompletable: (item) => item.status === 'normal',
      isUndoable: (item) => item.status.startsWith('transitionTo'),
      canAddBackToChecklist: (item) => item.status === 'complete',
      transitionToStatus: () => 'transitionToComplete'
    },
    complete: {
      type: () => 'To-Do',
      isCompletable: (item) => item.status === 'normal',
      isUndoable: (item) => item.status.startsWith('transitionTo'),
      canAddBackToChecklist: (item) => item.status === 'complete',
      transitionToStatus: () => 'transitionToNormal'
    },
    transitionToComplete: {
      type: () => 'To-Do',
      isCompletable: (item) => item.status === 'normal',
      isUndoable: (item) => item.status.startsWith('transitionTo'),
      canAddBackToChecklist: (item) => item.status === 'complete',
      transitionToStatus: () => 'complete',
      cancelTransitionStatus: () => 'normal'
    },
    transitionToNormal: {
      type: () => 'To-Do',
      isCompletable: (item) => item.status === 'normal',
      isUndoable: (item) => item.status.startsWith('transitionTo'),
      canAddBackToChecklist: (item) => item.status === 'complete',
      transitionToStatus: () => 'normal',
      cancelTransitionStatus: () => 'complete'
    }
  })
);



// WEBPACK FOOTER //
// ./app/lib/checklist/strategies/checklist_item_strategy.ts